import { render, staticRenderFns } from "./guidePanel.vue?vue&type=template&id=453ea8f8&scoped=true"
import script from "./guidePanel.vue?vue&type=script&lang=js"
export * from "./guidePanel.vue?vue&type=script&lang=js"
import style0 from "./guidePanel.vue?vue&type=style&index=0&id=453ea8f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ea8f8",
  null
  
)

export default component.exports